import React, { useState } from "react";
import { openDiscord, openSteam } from "../../../shared/utils";
import { GameClient } from "../gameClient";
import { UIButtonSmall } from "../styles/ButtonStyle";
import { Modal } from "./Modal";
import { getVersionString } from "../../../shared/version";

interface CreditsPanelProps {
    dismiss: () => void;
}

declare var gameClient: GameClient;

export const CreditsPanel = (props: CreditsPanelProps) => {
    return (
        <Modal isOpen={true} onClose={props.dismiss}>
            <div>
                <h2>Credits</h2>
                <p>
                    Auto Immune
                    © 2023 Distant Signal Games <br />
                    A game by Reza Ghassemi and Mark Dizon<br />
                    <br />
                    Game Design and Implementation - Reza Ghassemi, Mark Dizon<br />
                    Graphics Engineering - Reza Ghassemi<br />
                    UI and Art - Mark Dizon<br />
                    QA Specialist - Isaac Ramos<br />
                    Music and Sound Direction - Scott Stinson<br />
                    Visual Design - Virginia Kitchen<br />
                </p>

                {process.env.is_demo && <p>If you like the game, wishlist it on steam!</p>}
                <p>Join our Discord for the latest updates!</p>

                <p>Auto Immune {process.env.is_demo ? "Demo " : ""}{getVersionString()}</p>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    justifyContent: "space-evenly",
                }}>
                    {process.env.is_demo && <UIButtonSmall onClick={openSteam}>Wishlist!</UIButtonSmall>}
                    <UIButtonSmall onClick={openDiscord}>Join Discord</UIButtonSmall>
                </div>
            </div>
        </Modal>
    )
}
